import React from "react";

import BrandIcon from "./BrandIcon";
import Button from "../elements/Button";
import { useSettings } from "../lib/useSettings";

export default function Footer() {
  const { settings } = useSettings();

  return (
    <footer className="border-t border-slate-100 bg-white pb-8 pt-14">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
          <div>
            <BrandIcon />
            <img
              src="https://images.seeklogo.com/logo-png/30/2/fssai-logo-png_seeklogo-304263.png"
              alt="FSSAI licensed"
              loading="lazy"
              className="mt-6 h-20 w-auto"
            />
            <p className="mt-3 text-sm text-slate-400">Lic. No.: {settings.licenseNo}</p>
          </div>

          <div>
            <h3 className="mb-3 font-display text-lg text-maroon-800">Contact</h3>
            <p className="text-slate-500">
              <a href={`mailto:${settings.email}`} className="hover:text-maroon-700 hover:underline">
                {settings.email}
              </a>
            </p>
            <p className="mt-1 text-slate-500">
              <a
                href={`tel:${settings.footerPhone.replace(/[^+\d]/g, "")}`}
                className="hover:text-maroon-700 hover:underline"
              >
                {settings.footerPhone}
              </a>
            </p>
          </div>

          <div>
            <h3 className="mb-3 font-display text-lg text-maroon-800">Social</h3>
            <Button
              href={settings.instagramUrl}
              type="link"
              target="_blank"
              className="flex text-slate-500 hover:text-maroon-700 hover:underline"
              isExternal
            >
              Instagram
            </Button>
            <Button
              href={settings.linkedinUrl}
              type="link"
              target="_blank"
              className="mt-1 flex text-slate-500 hover:text-maroon-700 hover:underline"
              isExternal
            >
              LinkedIn
            </Button>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-100 pt-6 text-center">
          <p className="font-medium text-slate-600">V R FOOD PRODUCTS</p>
          <p className="mx-auto mt-1 max-w-xl text-sm text-slate-400">{settings.address}</p>
          <p className="mt-4 text-xs text-slate-300">
            © {new Date().getFullYear()} VR Food Products. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
